// localStorage bywa niedostępny: zablokowane dane witryny (sam odczyt window.localStorage rzuca SecurityError),
// tryb prywatny, brak miejsca (setItem rzuca QuotaExceededError). Każdy dostęp idzie przez te funkcje:
// ankieta działa bez localStorage, tracimy tylko znacznik „już wypełniona” i próg ustawiany w testach Cypressa.
export const readStorage = (key) => {
  try {
    return window.localStorage.getItem(key)
  } catch (error) {
    return null
  }
}

export const writeStorage = (key, value) => {
  try {
    window.localStorage.setItem(key, value)
    return true
  } catch (error) {
    return false
  }
}
